import { render, staticRenderFns } from "./TheAddEditRole.vue?vue&type=template&id=01c055aa&"
import script from "./TheAddEditRole.vue?vue&type=script&lang=js&"
export * from "./TheAddEditRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports